import { cn } from '@/lib/cn';

interface ProgressBarProps {
  value: number;
  max: number;
  label: string;
  className?: string;
  tone?: 'brand' | 'subject' | 'sun';
}

export function ProgressBar({ value, max, label, className, tone = 'brand' }: ProgressBarProps) {
  const percent = max === 0 ? 0 : Math.round((Math.min(value, max) / max) * 100);
  const fill =
    tone === 'subject' ? 'bg-[var(--subject)]' : tone === 'sun' ? 'bg-sun-500' : 'bg-brand-500';
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={max}
      aria-valuenow={Math.min(value, max)}
      className={cn('h-3 w-full overflow-hidden rounded-full bg-surface-muted', className)}
    >
      <div
        className={cn('h-full rounded-full transition-[width] duration-500', fill)}
        style={{ width: `${percent}%` }}
      />
    </div>
  );
}
